import * as React from "react";
import { List, Datagrid, TextField } from "react-admin";
import { Dialog, DialogContent } from "@material-ui/core";
import { CustomDateField } from "../../Components/CustomDateField";
import OldDataFileLink from "./OldDataFileLink";

const OldDataFileList = props => {
  const { openFiles, handleCloseFiles, selectedRequestId } = props;

  return (
    <Dialog fullWidth maxWidth={"md"} open={openFiles} onClose={handleCloseFiles} aria-labelledby="files-dialog-title">
      <DialogContent>
        {selectedRequestId && (
          <List
            basePath="masterfiles/existingfiles"
            resource="masterfiles/existingfiles"
            filter={{ relId__eq: selectedRequestId }}
            sort={{ field: "id", order: "ASC" }}
            title={"Files"}
            bulkActionButtons={false}
            exporter={false}
            empty={false}
            actions={false}
          >
            <Datagrid>
              <OldDataFileLink {...props} />
              <TextField source="fileName" label="Filename" />
              <TextField source="modifiedBy" label="Created By" />
              <CustomDateField source="modifiedDate" label="Created Date" showTime />
            </Datagrid>
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OldDataFileList;
